module.exports = __webpack_public_path__ + "static/assets/a949c4e23abbf996e494bcb1a4416c83.svg";